import { render } from "./ImageItem.vue?vue&type=template&id=5ec669a3&scoped=true"
import script from "./ImageItem.vue?vue&type=script&lang=js"
export * from "./ImageItem.vue?vue&type=script&lang=js"

import "./ImageItem.vue?vue&type=style&index=0&id=5ec669a3&scoped=true&lang=css"

import exportComponent from "/home/viewchat/public_html/viewchat-web-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ec669a3"]])

export default __exports__